import UAParser from 'ua-parser-js';

export const DEFAULT_DOCUMENT_TITLE = 'Horizon · SkySpecs';

let organizationTitle: string | null = null;
let pageTitle: string | null = null;

const updateDocumentTitle = () => {
  const baseTitle = organizationTitle
    ? `Horizon · ${organizationTitle} · SkySpecs`
    : DEFAULT_DOCUMENT_TITLE;
  document.title = pageTitle ? `${pageTitle} | ${baseTitle}` : baseTitle;
};

export function setTitle(title?: string | null, options: { isOrg?: boolean } = {}) {
  if (options.isOrg) {
    setOrganizationTitle(title ?? null);
    return;
  }

  pageTitle = title ?? null;
  updateDocumentTitle();
}

export function setOrganizationTitle(title: string | null) {
  organizationTitle = title;
  updateDocumentTitle();
}

export function resetDocumentTitleState() {
  organizationTitle = null;
  pageTitle = null;
  updateDocumentTitle();
}

export function isIE() {
  const parser = new UAParser();
  return parser.getBrowser().name === 'IE';
}
